<template>
  <div @load="loading">
    <div class="gameplay_title_container">
      <div class="gameplay_title">
        {{ gameInfo.question }}
      </div>
    </div>

    <div class="gameplay_game_box_list gameplay_tap_box" >
      <div class="gameplay_tap_container" >
        <div v-for="(row, rowIndex) in numOfRow" :key="row" class="gameplay_tap_row">
          <button v-for="(answer, index) in numOfCols" :key="index"
                  @click="sendAnswer(twoDimensionalTable[rowIndex][index], rowIndex, index + 1)"
                  class="attention_btn curs_def" :ref="index + 1"
                  :style="!buttonPushed ? 'cursor:pointer' : 'pointer-events:none'"
                  :disabled="buttonPushed">
            {{ twoDimensionalTable[rowIndex][index] }}
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint no-console: "off", no-plusplus: "off" */
import { mapState, mapGetters } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { gameplayFooter } from '@/common/jQuery';


export default {
  name: 'attentionNumbers',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      gameInfo: null, // NEW
      buttonPushed: false,
      twoDimensionalTable: [], // NEW
      numOfRow: 0,
      numOfCols: 4,
    };
  },
  mounted() {
    this.$nextTick(() => { this.loading(); });
  },
  created() {
    this.initGameData();
  },
  methods: {
    loading() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
      this.createMatrix();
    },
    createMatrix() {
      let index = 0;
      this.numOfRow = this.gameInfo.integerList.length === 24 ? 6 : 4;
      this.twoDimensionalTable = Array(this.numOfRow).fill().map(() => Array(this.numOfCols).fill());
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          this.twoDimensionalTable[i][j] = this.gameInfo.integerList[index++];
        }
      }
    },
    disableDiv(rowIndex, colIndex) {
      return this.buttonPushed || this.$refs[colIndex][rowIndex].classList.contains('attention_btn_correct');
    },
    playNextGame(isCorrectAnswer) {
      setTimeout(() => {
        this.normalTransition = true;
        this.storeBrainiacGameData(isCorrectAnswer);
        this.buttonPushed = false;
      }, 1500);
    },
    sendAnswer(value, rowIndex, colIndex) {
      if (this.buttonPushed || this.$refs[colIndex][rowIndex].classList.contains('attention_btn_correct')) {
        console.log('--> User 2 times. Wait for Answer....');
      } else {
        this.buttonPushed = true;
        this.$axios({
          url: `api/sendAnswerBrainiac?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${value}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).then((response) => {
          const responseData = response.data.data;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (responseData.status === 'WRONG_ANSWER') {
              this.$refs[colIndex][rowIndex].classList.add('attention_btn_wrong');
              this.playNextGame(false);
            } else if (responseData.status === 'CORRECT_ANSWER') {
              this.buttonPushed = false;
              this.$refs[colIndex][rowIndex].classList.add('attention_btn_correct');
            } else if (responseData.status === 'USER_FOUND_ALL_PAIRS') {
              this.$refs[colIndex][rowIndex].classList.add('attention_btn_correct');
              this.playNextGame(true);
            } else {
              // something bad happened
            }
          }
        }).catch((error) => {
          console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
        });
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'gameType',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/attention/AttentionNumbers.vue